module.exports = __webpack_public_path__ + "img/zheda.c545b814.jpg";